import React, { Component } from 'react'
import OrderedList from '../components/OrderedList'
import Paragraph from '../components/Paragraph'
import Prompts from '../components/Prompts'

export default class ThirdSessionPrompts extends Component {
  render() {
    return (
      <Prompts>
        <Prompts.Q>
          <OrderedList>
            <OrderedList.Item str="prose.whatStoodOut" />
            <OrderedList.Item str="prose.whatWasYourTake" />
            <OrderedList.Item str="prose.whatWasDifferent" />
            <OrderedList.Item str="prose.whatWasMostHelpful" />
          </OrderedList>
        </Prompts.Q>
        <Prompts.R str="prose.itSoundsLike" />
        <Prompts.P>
          <Paragraph str="prose.greatNextArea" />
          <Paragraph str="prose.orSayNextArea" />
        </Prompts.P>
      </Prompts>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ThirdSessionPrompts.js